'use client';

import { type FragmentType, getFragmentData } from '@gql';
import { useParams } from 'next/navigation';
import { VildarIframeSectionFragment } from './iframe-gql';
import { IframeContainer } from './iframe.style';

type Props = FragmentType<typeof VildarIframeSectionFragment>;

const Qlang = {
  is: 'ISL',
  en: 'EN',
};

export function Iframe(props: Props) {
  const { locale } = useParams() as { locale: string };

  const { forms } = getFragmentData(VildarIframeSectionFragment, props);

  if (!forms) return null;

  return (
    <IframeContainer>
      <iframe
        src={
          `${forms.iframe_url?.href}${
            forms.iframe_type === 'qualtrics' ? `?Q_lang=${Qlang[locale as keyof typeof Qlang]}` : ''
          }` || '/'
        }
      />
    </IframeContainer>
  );
}
